import { Album } from '../../models/Album';
import { ROLES } from '@/models/User';
import { userIs } from '@/helpers/auth';
import { getI18nInstance as i18n } from '@/i18n';

export default {
    namespaced: true,
    state: {
        error: null,
        userRootAlbum: null,
        loaded: false,
    },
    mutations: {
        userRootAlbum(state, album) {
            state.userRootAlbum = album;
            state.loaded = true;
        },
        isLoaded(state, loaded) {
            state.loaded = loaded;
        },
        setError(state, error) {
            state.error = error;
        },
    },
    actions: {
        /**
         * Loads all the user's album into one root album (state.userRootAlbum):
         * This differs for event organizers and admins: admins see global albums (shared),
         * while organizers only see their own albums.
         */
        async loadUserRootAlbum({ commit, state }, { force = false } = {}) {
            if (state.loaded && !force) {
                return;
            }
            commit('loading', true, { root: true });
            commit('isLoaded', false);
            const userRootAlbum = new Album({
                id: 0, // 0-id: this is the top album
                title: userIs(ROLES.EVENT_ORGANIZER) ? i18n().t('medien') : i18n().t('global_media'),
            });
            commit('userRootAlbum', userRootAlbum);
            await userRootAlbum.loadChildren();
            commit('loading', false, { root: true });
        },
    },
};
